import { OptionIndex } from './create-filter-index.function';
import { FieldState, FilterOptionDefinition, OptionState, RelatedDataInfoState } from '../../models';
import { treatUndefinedAsTrue } from './treat-undefined-as-true.function';

export function createOptionState(
  fieldState: FieldState,
  filterOption: FilterOptionDefinition<any>,
  optionIndex: OptionIndex
): OptionState {
  let relatedDataInfo: RelatedDataInfoState;

  if (optionIndex) {
    const dataIdKeys = optionIndex.dataIds ? Object.keys(optionIndex.dataIds) : [];

    relatedDataInfo = dataIdKeys.length
      ? dataIdKeys.reduce((result, key) => {
        result[key] = { nestedIds: Object.keys(optionIndex.dataIds[key].nestedData) };
        return result;
      }, {})
      : null;
  }

  return {
    id: filterOption.optionId || filterOption.value,
    fieldId: fieldState.id,
    value: filterOption.value,
    exactValue: filterOption.exactValue,
    icon: optionIndex?.iconPath ?? filterOption.icon,
    translationKey: filterOption.translationKey,
    isDisplayed: treatUndefinedAsTrue(fieldState.displayed) && treatUndefinedAsTrue(filterOption.displayed),
    isChecked: !!filterOption.checkedByDefault,
    isCheckedByDefault: !!filterOption.checkedByDefault,
    useCheckedByDefaultAfterReset: treatUndefinedAsTrue(filterOption.useCheckedByDefaultAfterReset),
    isFixed: false,
    showOnZeroCount: !fieldState.hideInZeroCount,
    notTrackedInQueryParams: filterOption.notTrackedInQueryParams,
    relatedDataInfo: relatedDataInfo ? relatedDataInfo : {},
    hasRelatedData: !!relatedDataInfo,
    tooltipTranslationKey: filterOption.tooltipTranslationKey,
    reverseFilter: filterOption.reverseFilter
  };
}
